import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from 'store/store';

import {
   type CoatThickness,
   type CoatType,
   type GeneralState,
   JOB_STATUS,
   type SelectedImageView,
   type Settings,
   type ThreeJSDataTypes,
} from './general.types';

const initialState: GeneralState = {
   flag: false,
   settings: {
      connectionId: '',
      folderName: '',
      jobStatus: JOB_STATUS.INITIAL,
   },
   decodedThreeJSData: {
      printBW: '',
      printColor: '',
   },
   selectedImageView: '',
   isLibraryVisible: false,
   coatType: null,
   coatThickness: 'mid',
   previewZoom: 100,
   selectedLayer: '',
};

const generalSlice = createSlice({
   name: 'general',
   initialState,
   reducers: {
      resetState: (state) => {
         Object.assign(state, initialState);
      },
      setFlag: (state, action: PayloadAction<boolean>) => {
         state.flag = action.payload; // state here can be mutable, because redux toolkit makes it immutable under the hood. no worries about it
      },
      updateSettings: (state, action: PayloadAction<Partial<Settings>>) => {
         // eslint-disable-next-line no-console
         console.log('ACT', action.payload);
         state.settings = { ...state.settings, ...action.payload };
      },

      setDecodedImageData: (state, action: PayloadAction<ThreeJSDataTypes>) => {
         return {
            ...state,
            decodedThreeJSData: action.payload,
         };
      },

      resetDecodedImageData: (state) => {
         return {
            ...state,
            decodedThreeJSData: {
               printBW: '',
               printColor: '',
            },
         };
      },

      selectImageView: (state, action: PayloadAction<SelectedImageView>) => {
         return {
            ...state,
            selectedImageView: action.payload,
         };
      },

      changeLibraryVisibility(state, action: PayloadAction<boolean>) {
         return {
            ...state,
            isLibraryVisible: action.payload,
         };
      },

      setCoatType: (state, action: PayloadAction<CoatType | null>) => {
         state.coatType = action.payload;
      },
      setCoatThickness: (state, action: PayloadAction<CoatThickness>) => {
         state.coatThickness = action.payload;
      },
      setPreviewZoom: (state, action: PayloadAction<number>) => {
         state.previewZoom = action.payload;
      },
      setSelectedLayer: (state, action: PayloadAction<string>) => {
         state.selectedLayer = action.payload;
      },
   },
});

export const stateOfGeneralSlice = (state: RootState) => state.general;
export const {
   resetState,
   setFlag,
   updateSettings,
   setDecodedImageData,
   selectImageView,
   resetDecodedImageData,
   changeLibraryVisibility,
   setCoatType,
   setCoatThickness,
   setPreviewZoom,
   setSelectedLayer,
} = generalSlice.actions;

export default generalSlice.reducer;
